import axios from 'axios';
import Vue from 'vue';

const state = {
    active: null,
    simulation: null
};

const mutations = {
    load(state, chapter){
        state.active = chapter;
        state.simulation = null;
    },
    simulation(state, simulation){
        console.log(`Focusing simulation`, simulation);
        state.simulation = simulation;
    }
};

const actions = {
    load({commit, state}, {product_id, chapter_id}){
        return axios.get(`/products/${product_id}/chapters/${chapter_id}`).then(response => commit('load', response.$data));
    },
    simulation({commit}, event){
        if(event.hasOwnProperty('simulation')){
            commit('simulation', event.simulation);
        }
    },
    interaction({commit}, event){}
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
